import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Queue from "@/pages/Queue";
import CalendarPage from "@/pages/CalendarPage";
import Releases from "@/pages/Releases";
import Connections from "@/pages/Connections";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";
import AdeOutreachPage from "@/pages/ade/AdeOutreachPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/register" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/queue" element={<ProtectedRoute><Layout><Queue /></Layout></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><Layout><CalendarPage /></Layout></ProtectedRoute>} />
      <Route path="/releases" element={<ProtectedRoute><Layout><Releases /></Layout></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><Layout><Analytics /></Layout></ProtectedRoute>} />
      <Route path="/ade-outreach" element={<ProtectedRoute><Layout><AdeOutreachPage /></Layout></ProtectedRoute>} />
      <Route path="/connections" element={<ProtectedRoute><Layout><Connections /></Layout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                borderRadius: "2px",
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "12px",
                letterSpacing: "0.05em",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
